import { Component, OnInit } from '@angular/core';
import {
  getTipoSistemaKey,
  TipoSistemaKey,
} from 'app/interfaces/enum/tipo-sistema';
import { ParametroHttpService } from '../parametro/parametro-http.service';
import { MessageService } from 'app/utils/toastr-custom/message.service';
import handleErrorMessage from 'app/utils/error-message-handler';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  tipoSistemas: TipoSistemaKey[] = [];

  isAgenciamentoCarga = false;
  isTransporteRodoviario = false;
  carregandoTipoSistema = true;

  constructor(
    private parametroHttpService: ParametroHttpService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.getTipoSistema();
  }

  private getTipoSistema(): void {
    this.carregandoTipoSistema = true;

    this.tipoSistemas = [];
    this.isAgenciamentoCarga = false;
    this.isTransporteRodoviario = false;

    this.parametroHttpService
      .getParametroByName('PARAM_TIPO_SISTEMA')
      .subscribe({
        next: parametro => {
          const valores = Array.isArray(parametro?.valor)
            ? parametro.valor
            : [parametro?.valor];

          this.tipoSistemas = valores
            .map(valor => getTipoSistemaKey(valor))
            .filter(
              (tipoSistema): tipoSistema is TipoSistemaKey =>
                tipoSistema !== null
            );
            console.log(this.tipoSistemas);

          this.isAgenciamentoCarga =
            this.tipoSistemas.includes('AGENCIAMENTO_CARGA');

          this.isTransporteRodoviario =
            !this.isAgenciamentoCarga &&
            this.tipoSistemas.includes('TRANSPORTE_RODOVIARIO');

          this.carregandoTipoSistema = false;
        },
        error: error => {
          this.carregandoTipoSistema = false;

          handleErrorMessage(this.messageService, error);
        },
      });
  }
}